import { render, staticRenderFns } from "./JoinedGroups.vue?vue&type=template&id=6c07011c&scoped=true&"
import script from "./JoinedGroups.vue?vue&type=script&lang=js&"
export * from "./JoinedGroups.vue?vue&type=script&lang=js&"
import style0 from "./JoinedGroups.vue?vue&type=style&index=0&id=6c07011c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c07011c",
  null
  
)

component.options.__file = "JoinedGroups.vue"
export default component.exports